/**
 * Fetch wrapper for the admin server routes.
 *
 * Unlike apps/library and apps/store, admin routes are called with the
 * full path already baked in by each caller (e.g.
 * `api.get('/api/admin/users?search=...')`) — there's no shared base
 * path or query-object builder here, and errors carry their body as raw
 * text (never parsed as JSON): callers read `err.body || err.message`.
 * That's admin's original, pre-refactor behavior, preserved via the
 * `errorBodyAs: 'text'` option on the shared core in
 * src/shared/api-fetch.js (see that file for what's common vs.
 * app-specific across the three app bundles).
 *
 * Each method also accepts a trailing options bag whose `signal` is
 * forwarded to the shared core (and on to fetch) so a screen can share
 * ONE AbortController/deadline across all of an operation's requests (see
 * lib/admin-lifecycle.js `createOperation`). Everything else — method,
 * body, `errorBodyAs:'text'`, `credentials:'include'`, JSON serialization,
 * and Content-Type — is unchanged and still handled inside sharedRequest.
 */
import { request as sharedRequest } from '../../../src/shared/api-fetch.js';

async function request(method, path, body, opts) {
  return sharedRequest(path, { method, body, errorBodyAs: 'text', signal: opts?.signal });
}

export const api = {
  get:    (path, opts)       => request('GET', path, undefined, opts),
  post:   (path, body, opts) => request('POST', path, body, opts),
  patch:  (path, body, opts) => request('PATCH', path, body, opts),
  delete: (path, body, opts) => request('DELETE', path, body, opts),
};
